var changeEvent = function (name, value) {
    return {
        target: {
            value: value,
            name: name,
        },
        type: "change",
    };
};

export { changeEvent };
